import GamificationService from '../components/gamification/gamification.service';
import DocsService from '../components/docs/docs.service';
import UserResolver from '../authentication/user-resolver';
import { FourOhFourComponent } from '../ng-app/four-oh/four-oh-four.component';
import { FourOhOneComponent } from '../ng-app/four-oh/four-oh-one.component';
import { GamificationComponent } from '../ng-app/gamification/gamification.component';
import { EmojiComponent } from '../ng-app/emoji/emoji.component';
import { EmojiCategoryComponent } from '../ng-app/emoji/emoji-category.component';
import { HallOfFameComponent } from '../ng-app/hall-of-fame/hall-of-fame.component';

const PseudoStaticRouter = {
  route: (module) => {
    module
      .service('GamificationService', GamificationService)
      .service('DocsService', DocsService);

    module.config(['$stateProvider', ($stateProvider) => {
      $stateProvider
        .state('fourohfour', {
          url: '/404',
          parent: 'root',
          component: FourOhFourComponent,
          resolve: {
            title: [() => 'uTest - 404'],
            user: UserResolver,
          },
        })
        .state('fourohone', {
          url: '/401',
          parent: 'root',
          component: FourOhOneComponent,
          resolve: {
            title: [() => 'uTest - 401'],
            user: UserResolver,
            returnToUrl: ['$location', ($location) => $location.absUrl()],
          },
        })
        .state('gamification', {
          url: '/upoints',
          parent: 'root',
          component: GamificationComponent,
          resolve: {
            title: [() => 'uTest - Earning uPoints & Badges'],
          },
        })
        .state('halloffame', {
          url: '/hall-of-fame',
          parent: 'root',
          resolve: {
            periods: ['$injector', '$state', function ($injector, $state) {
              const HallOfFameService = $injector.get('HallOfFameService');
              HallOfFameService.getPeriods().subscribe(
                (periods) => {
                  if (periods && periods.length > 0) {
                    // Get the most recent year and its first period
                    const latestYear = Math.max(...periods.map((p) => p.year));
                    const periodsForLatestYear = periods.filter((p) => p.year === latestYear);

                    if (periodsForLatestYear.length > 0 && periodsForLatestYear[0].period) {
                      const firstPeriod = periodsForLatestYear[0].period;
                      $state.go('halloffamedate', { year: latestYear, period: firstPeriod });
                    }
                  }
                },
                (error) => {
                  console.error('Error loading Hall of Fame periods:', error);
                },
              );
            }],
            title: [() => 'uTest Hall of Fame'],
          },
        })
        .state('halloffamedate', {
          url: '/hall-of-fame/:year/:period',
          component: HallOfFameComponent,
          parent: 'root',
          resolve: {
            periods: ['$injector', function ($injector) {
              const HallOfFameService = $injector.get('HallOfFameService');
              return new Promise((resolve) => {
                HallOfFameService.getPeriods().subscribe((periods) => {
                  resolve(periods);
                });
              });
            }],
            title: [() => 'uTest Hall of Fame'],
          },
        })
        .state('emoji', {
          url: '/emoji',
          component: EmojiComponent,
          parent: 'root',
          resolve: {
            title: [() => 'uTest Emojis'],
          },
        })
        .state('emoji.category', {
          url: '/:category',
          params: {
            category: '',
          },
          component: EmojiCategoryComponent,
          resolve: {
            title: [() => 'uTest Emojis'],
          },
        })
        .state('docs', {
          url: '/docs/{encryptedUrl}',
          parent: 'root',
          resolve: {
            encryptedUrl: ['$transition$', 'DocsService', '$state', '$window', function ($transition$, DocsService, $state, $window) {
              DocsService.find($transition$.params().encryptedUrl)
                .then((response) => {
                  $window.open(response.data.redirect_url, '_self');
                })
                .catch((_response) => {
                  $state.go('fourohfour');
                });
            }],
          },
        });
    }]);
  },
};

export default PseudoStaticRouter;
